"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconPlay', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M15 8C15 8.34562 14.8215 8.66674 14.528 8.84923L4.77802 14.9114C4.46966 15.1031 4.0816 15.1126 3.76421 14.9363C3.44683 14.7599 3.25 14.4253 3.25 14.0622L3.25 1.93782C3.25 1.57471 3.44683 1.24014 3.76421 1.06375C4.0816 0.887352 4.46966 0.896862 4.77802 1.08859L14.528 7.15077C14.8215 7.33326 15 7.65438 15 8ZM5.25 3.73712L5.25 12.2629L12.1061 8L5.25 3.73712Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M18 10C18 10.3573 17.8094 10.6874 17.5 10.8661L4 18.6603C3.6906 18.8389 3.3094 18.8389 3 18.6603C2.6906 18.4817 2.5 18.1515 2.5 17.7943L2.5 2.20581C2.5 1.84854 2.6906 1.51842 3 1.33978C3.3094 1.16115 3.6906 1.16115 4 1.33978L17.5 9.13401C17.8094 9.31265 18 9.64277 18 10ZM4.5 3.93786L4.5 16.0622L15 10L4.5 3.93786Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M21.5 12.5263C21.5 12.8835 21.3094 13.2137 21 13.3923L4.5 22.9186C4.1906 23.0972 3.8094 23.0972 3.5 22.9186C3.1906 22.74 3 22.4098 3 22.0526L3 3C3 2.64273 3.1906 2.31261 3.5 2.13397C3.8094 1.95534 4.1906 1.95534 4.5 2.13397L21 11.6603C21.3094 11.8389 21.5 12.169 21.5 12.5263ZM5 4.73205L5 20.3205L18.5 12.5263L5 4.73205Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M28.5 15.9904C28.5 16.3476 28.3094 16.6778 28 16.8564L5.5 29.8468C5.1906 30.0254 4.8094 30.0254 4.5 29.8468C4.1906 29.6682 4 29.338 4 28.9808L4 3C4 2.64273 4.1906 2.31261 4.5 2.13397C4.8094 1.95534 5.1906 1.95534 5.5 2.13397L28 15.1244C28.3094 15.303 28.5 15.6331 28.5 15.9904ZM6 4.73205L6 27.2487L25.5 15.9904L6 4.73205Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;